import useFadeIn from '../../hooks/useFadeIn';
import './About.css';

const facts = [
  { label: '25+ Years', detail: 'Engineering Leadership' },
  { label: 'Healthcare', detail: 'SaaS, IoT & Ad-Tech' },
  { label: 'Agile & AI', detail: 'Transformation & Strategy' },
  { label: 'UMaine', detail: 'B.A. Economics' },
];

const About = () => {
  const [ref, isVisible] = useFadeIn();

  return (
    <section className="about section" id="about">
      <div className={`container fade-in ${isVisible ? 'visible' : ''}`} ref={ref}>
        <p className="section-eyebrow">About</p>
        <h2 className="section-heading about__heading">Building Technology That Matters</h2>
        <div className="about__grid">
          <div className="about__narrative">
            <p>
              I've spent my career at the intersection of technology and business,
              helping organizations scale from founder-led teams to high-performing
              engineering functions of 40+ engineers. My focus has always been the same:
              build the culture, processes, and architecture that let great teams
              ship great products.
            </p>
            <p>
              From leading engineering at health-tech companies like Babyscripts and
              Validic, to building data platforms at ilumivu and scaling ad-tech
              infrastructure at Digital Turbine, I've operated across industries where
              reliability, performance, and user trust are non-negotiable.
            </p>
            <p>
              Today, through <a href="https://3dogsadvisory.com" target="_blank" rel="noopener noreferrer" className="about__link">3 Dogs Advisory</a>,
              I work as a Fractional CTO helping growth-stage companies build the
              engineering leadership, delivery processes, and AI-augmented workflows
              they need to move faster without breaking things.
            </p>
          </div>
          <div className="about__facts">
            {facts.map((fact, i) => (
              <div className="about__fact" key={i}>
                <span className="about__fact-label">{fact.label}</span>
                <span className="about__fact-detail">{fact.detail}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
